// O tooltip padrão do recharts tem fundo branco fixo e não define a cor do
// label, que herda text-foreground e some no tema escuro. Estes estilos
// acompanham o tema pelas variáveis do global.css.
export const chartTooltipContentStyle = {
  backgroundColor: "hsl(var(--background))",
  border: "1px solid hsl(var(--border))",
  color: "hsl(var(--foreground))",
};

export const chartTooltipLabelStyle = {
  color: "hsl(var(--foreground))",
  fontWeight: 600,
};
